import articlesData from './articles.json';
import type { ArticlesData, CheckCanReturnParams } from './types';

export const checkCanReturn = (params: CheckCanReturnParams) => {
  const { division, subDivision, category, subCategory } = params;

  if (!(division && subDivision && category && subCategory)) {
    return false;
  }
  return (articlesData as ArticlesData)[division]?.[subDivision]?.[category]?.includes(subCategory) || false;
};
